import { useEffect, useCallback } from "react";

const ScreenProtection = ({ children, username, watermarkText }) => {
  const displayName = watermarkText || username || "";
  const showWatermark = displayName.length > 0;

  // Block copy/paste/print keyboard shortcuts
  const handleKeyDown = useCallback((e) => {
    // Block Ctrl+C, Ctrl+S, Ctrl+P, Ctrl+A, Ctrl+U (view source)
    if ((e.ctrlKey || e.metaKey) && ["c", "s", "p", "a", "u"].includes(e.key.toLowerCase())) {
      // Allow Ctrl+C in dev tools (don't block if target is input)
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return;
      e.preventDefault();
    }
    // Block PrintScreen
    if (e.key === "PrintScreen") {
      e.preventDefault();
      navigator.clipboard.writeText("").catch(() => {});
    }
    // Block F12
    if (e.key === "F12") {
      e.preventDefault();
    }
  }, []);

  // Block right-click context menu
  const handleContextMenu = useCallback((e) => {
    if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return;
    e.preventDefault();
  }, []);

  // Block drag
  const handleDragStart = useCallback((e) => {
    e.preventDefault();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, [handleKeyDown, handleContextMenu, handleDragStart]);

  // Generate watermark grid positions
  const watermarkItems = [];
  for (let row = 0; row < 6; row++) {
    for (let col = 0; col < 4; col++) {
      watermarkItems.push({
        key: `${row}-${col}`,
        top: `${12 + row * 16}%`,
        left: `${8 + col * 25}%`,
        rotation: -22,
      });
    }
  }

  return (
    <div
      className="relative"
      style={{ userSelect: "none", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none" }}
      data-testid="screen-protection"
    >
      {/* Print blocker CSS */}
      <style>{`
        @media print {
          body * { display: none !important; }
          body::after {
            content: "PRINTING DISABLED — CONFIDENTIAL MATERIAL";
            display: block;
            font-size: 24px;
            text-align: center;
            padding: 100px;
            color: #F97316;
          }
        }
        ::selection { background: transparent; color: inherit; }
        ::-moz-selection { background: transparent; color: inherit; }
      `}</style>

      {/* Content */}
      {children}

      {/* Dynamic watermark overlay — only when authenticated */}
      {showWatermark && (
      <div
        className="fixed inset-0 pointer-events-none overflow-hidden"
        style={{ zIndex: 9999 }}
        data-testid="watermark-overlay"
      >
        {watermarkItems.map((item) => (
          <div
            key={item.key}
            className="absolute whitespace-nowrap"
            style={{
              top: item.top,
              left: item.left,
              transform: `rotate(${item.rotation}deg)`,
              opacity: 0.04,
              fontSize: "14px",
              fontWeight: 700,
              letterSpacing: "2px",
              color: "#FFFFFF",
              fontFamily: "monospace",
              textTransform: "uppercase",
            }}
          >
            {displayName} · {new Date().toISOString().split("T")[0]}
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default ScreenProtection;
